import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { Layout, Drawer, Menu, Modal, } from 'antd';
import { useSession } from 'components/Authenticated';
import { txt } from 'libs/i18n';
import clsx from 'clsx';
import { savingInProgressSignal } from 'screens/DashboardScreen/pages/EditorPage/signalsStore/savingState';
import { useAppSubdomain } from 'hooks/useAppSubdomain';
import styles from './style.module.less';
import { fullMenuContent } from './menu-content';
import DashMenuHead from '../DashMenuHead';
const createAntMenuItems = (items) => items.map((item) => {
    if (item.key === null) {
        return ({
            type: 'divider',
        });
    }
    return ({
        key: item.key,
        icon: item.icon,
        title: txt(item.key),
        label: txt(item.key),
        children: item.subItems === undefined
            ? undefined
            : createAntMenuItems(item.subItems),
    });
});
const DashMenu = ({ collapsed, isMobile, activeLink, allowedForTeam, onMenuCollapse, }) => {
    const { session: { login } } = useSession();
    const { isSubdomain } = useAppSubdomain();
    const history = useHistory();
    const [modal, contextHolder] = Modal.useModal();
    const menuContent = fullMenuContent
        .filterByStatus(login.claims, login.user.role)
        .filter((item) => item.allowedForTeam === undefined
        || item.allowedForTeam === allowedForTeam);
    const handleSelect = ({ keyPath }) => {
        if (savingInProgressSignal.value) {
            void modal.confirm({
                title: `${txt('confirmLeaving')}`,
                content: `${txt('unsavedChanges')}`,
                cancelText: `${txt('cancel')}`,
                okText: `${txt('leave')}`,
                okButtonProps: { type: 'primary', danger: true },
                onOk() {
                    history.push(`/${keyPath.reverse().join('/')}`);
                },
            });
        }
        else {
            history.push(`/${keyPath.reverse().join('/')}`);
        }
        if (isMobile) {
            onMenuCollapse(true);
        }
    };
    const menu = (_jsx(Menu, { mode: isMobile ? 'inline' : 'vertical', items: createAntMenuItems(menuContent.items), selectedKeys: [activeLink], onSelect: handleSelect, theme: "dark" }));
    const getMenuFooter = () => {
        if (isSubdomain) {
            return (_jsx("div", { className: clsx(styles.dashMenuTail, { [styles.dashMenuSmallTail]: collapsed }) }));
        }
        return null;
    };
    if (isMobile) {
        return (_jsxs(Drawer, { className: styles.dashMenu, placement: "left", open: !collapsed, onClose: () => onMenuCollapse(true), closeIcon: false, getContainer: false, children: [_jsx(DashMenuHead, {}), menu, getMenuFooter()] }));
    }
    return (_jsxs(Layout.Sider, { className: styles.dashMenu, collapsed: collapsed, collapsedWidth: "3.5rem", width: "14.5rem", breakpoint: "md", children: [_jsx(DashMenuHead, {}), menu, contextHolder, getMenuFooter()] }));
};
export default DashMenu;
